import { render, staticRenderFns } from "./SuspendedTab.vue?vue&type=template&id=9ac045ce&"
import script from "./SuspendedTab.vue?vue&type=script&lang=js&"
export * from "./SuspendedTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports